import _ from 'underscore';

export default class Colors{
    constructor(){
        let readColors = this.getStyle('chart-colors');
		this.client = process.env.REACT_APP_CLIENT
        
		let defaultColors = [
			'#007a53', 
            '#0098d0', 
            '#abc233', 
            '#2b5592',
            '#8a9191',
            '#c4d6ed',
            '#642f6c',
            '#3cb6ce',
            '#4f5353',
            '#7bbf00'
		]

		if (this.client === 'grpaa' ) {
			defaultColors = [
				'#002e57', 
				'#0098d0', 
				'#002e57', 
				'#2b5592',
				'#8a9191',
				'#c4d6ed',
				'#642f6c',
				'#3cb6ce',
				'#4f5353',
				'#002e57'
			]
		}
		
		this.colors = readColors || defaultColors;
    }

    getStyle(className) {
        var sheet = _.find(document.styleSheets, (item) => {
            return item.href === null;
        });
        if (!sheet)return null;

        var classes = sheet.rules || sheet.cssRules;
        var rule = _.find(classes, (item) => {
            return item.selectorText === '.' + className;
        });
        if (!rule)return null;

        var text = rule.cssText;
        var rulesChunk = text.split('{')[1];

        var rules = rulesChunk.split(';');        
        var output = [];
        _.each(rules, (rule) => {
            var cr = rule.split(':');
            if (cr.length > 1){
                output.push(cr[1].trim());
            }
        });

        return output.length > 1 ? output : null;
    }

    get(index){
        return this.colors[index];
    }
}